import { Button } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"

const ButtonBackFooter = ({ to = "" }) => {
  const navigate = useNavigate();

  return (
    <>{to &&
      <Button width="full" size="lg" borderRadius={0} colorScheme="blue" onClick={() => navigate(to)}>Voltar</Button>}
      {!to &&
        <Button width="full" size="lg" borderRadius={0} colorScheme="blue" onClick={() => navigate(-1)}>Voltar</Button>}
    </>
  )
}

export default ButtonBackFooter;